
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
    Avatar,ListItemIcon, ListItemText, Menu,
    Tooltip
} from "@mui/material";

// App Imports

import {deleteDataPoint, getAllDataPoints} from "./DataPointClient";
import {changeDataPoint} from "../DataPoint/dataPointSlice";
import ContractSectionMenu from "../Menus/ContractSectionMenu";
import DataPointDrawer from "../DataPoint/DataPointDrawer";
import CustomFooter from "../CommonComponents/GridCustomFooter";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import DataPointValueListDrawer from "./DataPointListDrawers/DataPointValueListDrawer";


import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {blue, deepOrange, deepPurple, lightGreen, red} from "@mui/material/colors";
import {CheckCircleOutline} from "@mui/icons-material";
import DataPointXrefListDrawer from "./DataPointListDrawers/DataPointXrefListDrawer";
import DataPointUseListDrawer from "./DataPointListDrawers/DataPointUseListDrawer";
import DataPointValueFilterListDrawer from "./DataPointListDrawers/DataPointValueFilterListDrawer";
import DataPointSectionFilterListDrawer from "./DataPointListDrawers/DataPointSectionFilterListDrawer";
import DataPointExpressionListDrawer from "./DataPointListDrawers/DataPointExpressionListDrawer";
import AddFiltersExportToolbar from "../CommonComponents/AddFiltersExportToolbar";
import {DataPointAttributeGridColumns} from "../DataPointAttribute/DataPointAttributeGridColumns";
import {changeDataPointAttribute} from "../DataPointAttribute/dataPointAttributeSlice";
import {DataPointGridColumns} from "./DataPointGridColumns";
import CsfInfoDialogue from "../ContractDrilldown/ContractDrilldownCSF/Info/CsfInfoDialogue";
import DpInfoDialogue from "./Info/DpInfoDialogue";

// main function
export default function DataPointGrid() {

    // ****************** BEGIN STATES ****************************

    const [dataPoints, setDataPoints] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showCRUD, setShowCRUD] = useState(true);
    const [dpInfoOpen, setDpInfoOpen] = useState(false);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorDataPointId = useSelector((state) => state.dataPointSlc.value.id);
    const selectorDataPointMcode = useSelector((state) => state.dataPointSlc.value.mcode);
    const selectorDataPointName = useSelector((state) => state.dataPointSlc.value.name);
    const selectorDataPointDescription = useSelector((state) => state.dataPointSlc.value.description);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const dispatchData = useDispatch();

    const selectorDpGridRefresh = useSelector(state => state.dataPointSlc.value.dpGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************
    //
    // const fetchDataPoints = () =>
    //     getAllDataPoints()

    //         .then(data => {
    //             console.log(data);
    //             setDataPoints(data);
    //         })
    // useEffect(() => {
    //     fetchDataPoints();
    // }, []);


    const fetchDataPoints = React.useCallback(() => {
        return getAllDataPoints()

            .then(data => {
                console.log(data);
                setDataPoints(data);
            });
    }, []);

    useEffect(() => {
        fetchDataPoints();
    }, [fetchDataPoints]);

    useEffect(() => {
        if (!selectorDpGridRefresh) return;

        fetchDataPoints().finally(() => {
            dispatchData(changeDataPoint({ dpGridRefresh: false }));
        });
    }, [selectorDpGridRefresh, fetchDataPoints, dispatchData]);
    //
    // useEffect(() => {
    //     fetchDataPoints();
    //     dispatchData(changeDataPoint({dpGridRefresh: false}));
    // }, [useSelector((state) => state.dataPointSlc.value.dpGridRefresh)===true]);



    // ****************** END FETCH ****************************

    //
    // const renderDataPoints = dataPoints => {
    //     if (dataPoints.length <= 0) {
    //         return "No Data";
    //     }}
    //
    // function handleControls(){
    //     setShowControls(!showControls)
    // }

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeDataPoint({id: 0, mcode: "", name: "", description: "",piiClassification: null, dataType: null,
            dpDrawerState: true, dpDrawerMode: "Add"}));
    };

    const handleEdit = (selectDataPointId, selectDataPointMcode, selectDataPointName, selectDataPointDescription, selectDataType, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, mcode: selectDataPointMcode, name: selectDataPointName,
            description: selectDataPointDescription, dataType: selectDataType, dpDrawerState: true,dpDrawerMode: "Edit" }));
    }

    const removeDataPoint = () => {
        deleteDataPoint(selectorDataPointId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeDataPoint({dpGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = (selectDataPointId, selectDataPointMcode, selectDataPointName, selectDataPointDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, mcode: selectDataPointMcode, name: selectDataPointName, description: selectDataPointDescription }));
        setDeleteOpen(true);
    };

    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // ****************** END CRUD ***********************************


    const handleDpInfo = () => {
        setDpInfoOpen(true);
    };

    const handleCloseDpInfo = () => {
        setDpInfoOpen(false);
    };




    // ****************** BEGIN DRILLDOWN ****************************

    const handleValues = (selectDataPointId,selectDataPointMcode, selectDataPointName, selectDataPointDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, name: selectDataPointName, cdpvListId: selectDataPointId, cdpvListDrawerState: true}));
        ;
    }
    const handleXrefs = (selectDataPointId,selectDataPointMcode, selectDataPointName, selectDataPointDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, name: selectDataPointName, dpxListId: selectDataPointId, dpxListDrawerState: true}));
        ;
    }

    const handleUses = (selectDataPointId,selectDataPointMcode, selectDataPointName, selectDataPointDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, name: selectDataPointName, dpuListId: selectDataPointId, dpuListDrawerState: true}));
        ;
    }

    const handleSectionFilter = (selectDataPointId,selectDataPointMcode, selectDataPointName, selectDataPointDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, name: selectDataPointName, csfListId: selectDataPointId, csfListDrawerState: true}));
        ;
    }

    const handleValueFilter = (selectDataPointId,selectDataPointMcode, selectDataPointName, selectDataPointDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, name: selectDataPointName, cdpvfListId: selectDataPointId, cdpvfListDrawerState: true}));
        ;
    }

    const handleExpressions = (selectDataPointId,selectDataPointMcode, selectDataPointName, selectDataPointDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeDataPoint({id: selectDataPointId, name: selectDataPointName, expressionListId: selectDataPointId, expressionListDrawerState: true}));
        ;
    }
    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (dataPoints) => {

        console.log(' data from clicked row');
        console.log(dataPoints);
        dispatchData(changeDataPoint({id: dataPoints.id,
            mcode: dataPoints.mcode, name: dataPoints.name,
            description: dataPoints.description,status:dataPoints.status, dataType: dataPoints.dataType}));
    };

    const handleMousedRow = (dataPoints) => {

        console.log(' data from clicked row');
        console.log(dataPoints);
        dispatchData(changeDataPoint({id: dataPoints.id,
            mcode: dataPoints.mcode, name: dataPoints.name,
            description: dataPoints.description,status:dataPoints.status, dataType: dataPoints.dataType,
        piiClassification: dataPoints.piiClassification, allowMany: dataPoints.allowMany}));
    };


    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                <h3  style={{cursor:'pointer'}}   onClick={() => handleDpInfo()}  >Data Points</h3>
                </Tooltip>
            </Box>
            <DpInfoDialogue
                open={dpInfoOpen}
                onClose={handleCloseDpInfo}
            />
            {showCRUD && <ContractSectionMenu/>}
            {useSelector((state) => state.dataPointSlc.value.dpDrawerState) &&
            <DataPointDrawer
                fetchDataPoints = {fetchDataPoints}
            />}
             {useSelector((state) => state.dataPointSlc.value.cdpvListDrawerState) &&
                 <DataPointValueListDrawer
            />}
            {useSelector((state) => state.dataPointSlc.value.dpxListDrawerState) &&
                <DataPointXrefListDrawer
                />}
            {useSelector((state) => state.dataPointSlc.value.dpuListDrawerState) &&
                <DataPointUseListDrawer
                />}
            {useSelector((state) => state.dataPointSlc.value.expressionListDrawerState) &&
                <DataPointExpressionListDrawer
                />}
            {useSelector((state) => state.dataPointSlc.value.csfListDrawerState) &&
                <DataPointSectionFilterListDrawer
                />}
            {useSelector((state) => state.dataPointSlc.value.cdpvfListDrawerState) &&
                <DataPointValueFilterListDrawer
                />}

            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"DataPoints"}
                rows={dataPoints}
                disableDensitySelector={true}
                disableColumnSelector={true}
                // columns={columns(fetchDataPoints)}
                // onRowMouseOver = {(dataPoints)=>handleMousedRow(dataPoints.row)}
                columns={DataPointGridColumns({
                    dataPoints,
                    hideActions,
                    handleValues,
                    handleMousedRow,
                    handleXrefs, handleUses,handleExpressions, handleSectionFilter, handleValueFilter,
                    onEdit: () => dispatchData(changeDataPoint({ dpDrawerState: true, dpDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeDataPoint({ dpDrawerState: true, dpDrawerMode: "Clone" })),
                    onDelete: removeDataPoint
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={dataPoint => dataPoint.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
        </div>
    );

    // ****************** END RETURN ****************************

}

